// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__2PhdX","row":"Node_row__3cATH","label":"Node_label__2hK-3","footer":"Node_footer__2njCf"};